module.exports = __webpack_public_path__ + "band_16_daughter.e09e4d45.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_16_daughter.png
// module id = aYW3
// module chunks = 0